module.exports = __webpack_public_path__ + "static/media/icon-graphic-congrats.fd093028.svg";